export default __webpack_public_path__ + "static/media/PrintingImg.108f2e08.png";